<template>
    <div class="tenant-management">
        <div class="tool-bar-mask"></div>
        <h1>租客管理</h1>
        <div class="develop">
            <img src="@/assets/img/pages/develop.svg" alt="">
        </div>
    </div>
</template>
<script>
export default {
    name: 'TenantManagement',
    data () {
        return {
        }
    },
    mounted () {
        this.$analytics.logEvent('租客管理', { screen_name: '租客管理'})
    },
}
</script>
<style lang="scss">
    .tenant-management{
        position: relative;
        margin-top: 42px;
        > h1{
            margin-top: 26px;
            margin-bottom: 40px;
            font-size: 28px;
        }
        .develop{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 1154px;
            height: 799px;
            border-radius: 8px;
            background: #fff;
        }
    }
    @media screen and (max-width: 1280px){
        .tenant-management{
            .develop{
                display: flex;
                align-items: center;
                justify-content: center;
                width: 1128px;
                height: 799px;
                border-radius: 8px;
                background: #fff;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/landlord/tenantManagementPages/TenantManagementDefault.vue